module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('h1', {
    staticClass: "block_114",
    attrs: {
      "id": "id_Toc151366860"
    }
  }, [_vm._v("Your Choice")]), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Some rose bright and early; they got there first and gained the world.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Others remained sleeping; they stayed put and ended with nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Some played along, singing and dancing; they won the jackpot.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Those that did not play ball found themselves failures.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Others stepped up, reaching for the top; they got wealthy.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("But some stayed sitting and remained stuck in their ways.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Some opened their eyes, saw the opportunities, and jumped in. They were fulfilled.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Those that opted out became immune and unaware; they were forgotten.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Others were strong and brave. They walked up to it and conquered.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Those that cowered and shied away from it were shamelessly defeated.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Some were quick and prepared, reached the finishing line, and won the game.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Others were not up to scratch; they became insignificant and faded into oblivion.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Some learned about it, mastered it, and became knowledgeable.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Those that loitered and wavered were left dumbfounded and ignorant.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Some were clever and driven by their dreams. They surpassed and became heroes.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("The mediocre and lazy missed the point. They were left out and missed out.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Those that were enlightened walked in the light with confidence and wisdom.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Others remained in the dark; they became desperate, and they despaired.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Some were filled with hope. They overcame and became great.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Others lost faith and became worthless.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Some gracefully accepted it and were richly rewarded.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Others grasped it by the neck; they were choked.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Those that were patient reaped the benefits, enjoying the interest.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("But those filled with impatience got wild. They were lost in the wilderness and perished.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Some were kind and nurturing. They received honour and were loved.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Those that were cruel and uncompromising were filled with guilt and felt unworthy.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Others sought peace and arbitration; they were earthly rewarded.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Those that sought to fight and brawl were doomed to the graves.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Some grabbed it with both hands and succeeded.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Others let it slip through their fingers and lost it all.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Some heard about it, mentored it, and profited.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Those that ignored it ended with a loss.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Some spoke out and advocated for others. They were awarded accolades.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Whilst those that remained silent were never heard and remained obscure.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Some saw it coming, grabbed it by both hands, and became powerful.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Others were blinded by its light and never got a chance.")]), _vm._v(" "), _c('p', {
    staticClass: "block_3",
    attrs: {
      "id": "calibre_pb_7"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b564f46","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_006.vue
// module id = 81
// module chunks = 0